/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  FailureResponseResponse,
  NotFoundResponse,
  SystemCashResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Returns list of system cash details of an accounting location
 * @summary System cash value of an accounting location
 */
export const getSystemCashAnAccountingLocation = (
  accountingLocationID: string,
  signal?: AbortSignal,
) => {
  return customInstance<SystemCashResponseResponse>({
    url: `/BboCashManagementService/v1/system-cash/accounting-location/${accountingLocationID}`,
    method: 'get',
    signal,
  });
};

export const getGetSystemCashAnAccountingLocationQueryKey = (accountingLocationID: string) => {
  return [
    `/BboCashManagementService/v1/system-cash/accounting-location/${accountingLocationID}`,
  ] as const;
};

export const getGetSystemCashAnAccountingLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSystemCashAnAccountingLocationQueryKey(accountingLocationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>> = ({
    signal,
  }) => getSystemCashAnAccountingLocation(accountingLocationID, signal);

  return { queryKey, queryFn, enabled: !!accountingLocationID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSystemCashAnAccountingLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>
>;
export type GetSystemCashAnAccountingLocationQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary System cash value of an accounting location
 */
export const useGetSystemCashAnAccountingLocation = <
  TData = Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSystemCashAnAccountingLocation>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSystemCashAnAccountingLocationQueryOptions(
    accountingLocationID,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
